/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_distance.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Computes the distance between two points.
 * For cartesian geometries, this is the pythagorean distance in the same units as the original coordinates.
 * For geographic geometries, this is the circular distance along the great circle in meters.
 *
 * @example
 * FROM airports
 * | WHERE abbrev == "CPH"
 * | EVAL distance = ST_DISTANCE(location, city_location)
 * | KEEP abbrev, name, location, city_location, distance
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'st_distance',
  signatures: [
    {
      params: [
        {
          name: 'geomA',
          type: 'cartesian_point',
          optional: false,
        },
        {
          name: 'geomB',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'geomA',
          type: 'geo_point',
          optional: false,
        },
        {
          name: 'geomB',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
